import { CarePlanCycleType } from 'shared/types/graphql';

export const getRenewalCycleInMonths = (renewalCycle?: CarePlanCycleType): number => {
  switch (renewalCycle) {
    case CarePlanCycleType.Monthly:
      return 1;
    case CarePlanCycleType.Semianually:
      return 6;
    default:
      return 12;
  }
};

export const getBillingCycleInMonths = (billingCycle?: CarePlanCycleType): number => {
  switch (billingCycle) {
    case CarePlanCycleType.Annually:
      return 12;
    case CarePlanCycleType.Semianually:
      return 6;
    default:
      return 1;
  }
};

export const getBillsPerRenewal = (renewalCycle?: CarePlanCycleType, billingCycle?: CarePlanCycleType): number => {
  return getRenewalCycleInMonths(renewalCycle) / getBillingCycleInMonths(billingCycle);
};
